import * as React from "react";
import { Text } from "@uikit";

interface IReviewAvgProps {
  rating: number;
  text: string;
  mode?: string;
  size?: string;
}

const ReviewAvgItem = ({
  rating,
  text,
  mode = "vertical",
  size = "large",
}: IReviewAvgProps) => {
  //calculate the percentage of the rating out of 5
  const percentage = (rating / 5) * 100;

  return (
    <div
      className={`flex ${size === "small" ? "mb-1" : "mb-4"} flex-row ${
        mode === "vertical" && "flex-col  justify-between content-center"
      }`}
    >
      <div className="flex justify-between mb-1">
        <Text
          size={13}
          color="black90"
          leading={1.5}
          className={`mb-0 order-1`}
        >
          {text}
        </Text>
        <Text
          size={13}
          color="black90"
          weight="semibold"
          leading={1.5}
          className={`mb-0 order-1`}
        >
          {rating}
        </Text>
      </div>
      <div className="flex">
        <div className="w-full bg-grey3 rounded-full h-[5px]">
          <div
            style={{ width: `${percentage}%` }}
            className={`bg-green h-[5px] rounded-full`}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default ReviewAvgItem;
